<template>
    <div>
        <vSelect :options="daytypeOptions" v-model="daytype" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


export default {
    name: "DaytypeSelect",
    components: {
        vSelect
    },
    props: {
        value: String
    },
    computed: {
        daytypeOptions: function() {
            var ret = [];
            if( this.listData )
                for( var a of this.listData ) {
                    ret.push({code: a.tunnus, label:a.tunnus + ' ' + a.kuvaus})
                }
            return ret;
        },
        daytype: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        },
        listData() {
            return this.$store.state.timetable.daytypes.list;
        },     
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
    },
    mounted() {
         if(!this.listData || this.listData.length === 0) 
             this.$store.dispatch('timetable/getDayTypeList')
    }
}
</script>